<template>
  <div>
    <b-card no-body class="mb-0">
      <b-row class="m-2">
        <b-col sm="6" md="3" class="mb-1 mb-md-0">
          <v-select
            size="sm"
            v-model="pagination.perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="pagination.perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block"
            @input="onChange"
          />
          <label class="mx-50">entries per page</label>
        </b-col>
        <b-col sm="7" md="7">
          <b-form-input
            v-model="search"
            class="d-inline-block mr-1 mb-1 mb-md-0"
            placeholder="Search..."
            @input="onChange"
          />
        </b-col>
        <b-col sm="5" md="2">
          <b-button
            block
            v-if="$can('create', 'user')"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="mb-1 mb-md-0"
            left
            variant="primary"
            @click="
              () => {
                $router.push('/user/form/new');
              }
            "
          >
            <span class="text-nowrap">Add User</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        bordered
        class="position-relative"
        :items="userList"
        responsive
        :fields="field"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(sr)="data">
          {{
            data.index + 1 + (pagination.currentPage - 1) * pagination.perPage
          }}
        </template>
        <template #cell(additionalUserData)="data">
          <div style = "display:flex ; justify-content: center; align-items:center">
          <feather-icon
                    style="cursor: pointer"
                    icon="InfoIcon"
                    size="23"
                    @mouseenter="handleHoveredId(data.item.user_id)"
                    @mouseleave="handleHoverRelease()"
                  />
          </div>
          <div v-if="hoveredUserId === data.item.user_id">
          <hover-metadata-component
            :item="{
              ...data.item,
              createdAt: formatDate(data.item.createdAt),
              updatedAt: formatDate(data.item.updatedAt),
            }"
            :idField="'user_id'"
            :createdAt="data.item.createdAt"
            :createdBy="data.item.createdBy_name"
            :updatedAt="data.item.updatedAt"
            :updatedBy="data.item.updatedBy_name"
            :isHovered="hoveredUserId === data.item.user_id"
            :showAbove="data.index >= itemsInRow - 3? true : false "
          />
        </div>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <feather-icon
            v-if="$can('update', 'user')"
            icon="EditIcon"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-b-tooltip.hover.v-primary
            variant="outline-primary"
            title="Edit"
            class="mr-1"
            @click="$router.push(`/user/form/${data.item.user_id}`)"
          />
        </template>
      </b-table>
      <template #footer>
        <div>
          <b-row>
            <b-col
              class="d-flex align-items-center justify-content-center justify-content-sm-center"
            >
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.total"
                :per-page="pagination.perPage"
                @change="onPageChange"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
                :limit="15"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardBody,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import * as UserServices from "@/apiServices/UsersServices";
import HoverMetadataComponent from "@/views/components/HoverMetadataComponent.vue";
import moment from "moment";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCardHeader,
    BCardBody,
    vSelect,
    VBTooltip,
    HoverMetadataComponent,
    FeatherIcon
  },

  data() {
    return {
      moment:moment,
      hoveredUserId: null,
      userList: [],
      field: [
        { label: "SR", key: "sr", sortable: true, thStyle: { width: "6rem" } },
        { label: "User", key: "name", sortable: true },
        { label: "Email", key: "email", sortable: true },
        { label: "Mobile", key: "mobile", sortable: true },
        {
          label: "Role",
          key: "role_name",
          sortable: true,
        },
        // { label: "Company", key: "company", sortable: true },
        // { key: "actions", thStyle: { width: "3rem" } },
        // {
        //   label: "Logs",
        //   key: "additionalUserData",
        // },
      ],
      search: "",
      // pagination: {
      //   currentPage: 1,
      //   perPage: 10,
      //   total: 0,
      // },
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        total: 0,
        perPageOptions: [10, 25, 50, 100],
      },
      itemsInRow: 10,
    };
  },

  methods: {
    formatDate(dateString) {
      console.log(dateString);
      if (!dateString) return "";
      if (
        dateString.startsWith("0000-00-00") ||
        !moment(dateString).isValid()
      ) {
        return "";
      } else {
        let val = moment(dateString).format("DD-MM-YYYY");
        console.log(val, "after-conversion");
        return val;
      }
    },
    handleHoveredId(hoveredId) {
      console.log(hoveredId, "hoveredId");
      this.hoveredUserId = hoveredId;
    },
    handleHoverRelease() {
      this.hoveredUserId = null;
    },
    onChange() {
      this.pagination.currentPage = 1; // Reset to first page on search or perPage change
      this.getAllUsers();
    },
    onPageChange(page) {
      this.pagination.currentPage = page;
      this.getAllUsers();
    },

    async getAllUsers() {
      try {
        const response = await UserServices.getAllUsers({
          search: this.search,
          perPage: this.pagination.perPage,
          currentPage: this.pagination.currentPage,
        });

        if (response.data.status) {
          this.userList = response.data.data.data;
          this.itemsInRow = this.userList.length;
          if (response.data.data.pagination.total) {
            this.pagination.total = response.data.data.pagination.total;
          }
          this.pagination.currentPage =
            response.data.data.pagination.currentPage;
        }
      } catch (error) {
        console.log("Error in getAllUsers ", error);
      }
    },
    updateColumns(){
      let columnField = [];
      if(this.$can('update', 'user')){
        columnField.push({ key: "actions", thStyle: { width: "3rem" } })
      }
      columnField.push({
          label: "Logs",
          key: "additionalUserData",
        });
      this.field = [...this.field, ...columnField];
    }
  },
  beforeMount() {
    this.getAllUsers();
    this.updateColumns();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.per-page-selector {
  width: 90px;
}
</style>
